export function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
export function validatePassword(password) {
    return password.length >= 8;
}
export function validatePasswordStrength(password) {
    if (password.length < 8)
        return 'weak';
    if (/[A-Z]/.test(password) && /[0-9]/.test(password))
        return 'strong';
    return 'medium';
}
//# sourceMappingURL=validation.js.map